import React from 'react';
import { Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

@inject('AuthStore')
@observer
class SignOut extends React.Component {
  constructor(props){
    super(props);
    props.AuthStore.signOut()
  }
  render(){
    return(  <Redirect to= '/'/> )
  }
  
};

export default SignOut;
